
import React, { useState, useEffect, useContext } from "react";


import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";

import SweetAlert from 'react-bootstrap-sweetalert';
import * as Config from "../constants/Config";
import Loader from "../components/loader";
import { contentContext } from "../context/contentContext";
import SessionPopup from "../pages/SessionPopup"
import TableLoader from "../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import LocationSearch from "./LocationSearch";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
let { lambda, appname } = window.app

const BusinessProfile = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");
    const [countries, setCountries] = useState('');
    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);
    const [toastType, setToastType] = useState("");// State for dynamic message
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);
    const [files, setFiles] = useState([]);

    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [selectedPlace, setSelectedPlace] = useState('');
    const [addressData, setAddressData] = useState({});
    const [filesData, setFilesData] = useState([]);
    const [disableSaveBtn, setDisableSaveBtn] = useState(false);
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    const [btnLoader, setBtnLoader] = useState(false);
    const [error, setError] = useState('');

    const [image, setImg] = useState('');
    // const [sortDirection, setSortDirection] = useState('asc');

    // let siteConfig = window?.site?.common;
    // let appResourcesUrl = siteConfig?.imageCloudfront;

    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const { clientInfo, setClientInfo, searchedFlag, businessData, setBusinessData, setSearchedFlag, isLoading, mapsAPIkey, setIsLoading, userData, setUserData, GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "User Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setSearchedFlag(false);
            setUserSearch("")
        }
    }, [prevRoute]);

    useEffect(() => {
        // getclient()
    }, []);

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);


    useEffect(() => {
        setRoute("user")
        //  GetClientDataContext()
        setActiveMenuId("")
        // setActiveMenuObj({
        //     "Client Management": false,
        //     "Contact Management":false,
        //     "Reports": false
        // })
        userActivity();
    }, []);

    useEffect(() => {
        if (toastMessage && toastType && toast[toastType]) {
            toast[toastType](toastMessage, {
                position: "bottom-center",
                // autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage && setToastMessage("");
        }
    }, [toastMessage, toastType]);




    useEffect(() => {

        GetCountries()
    }, []);


    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/signin");
            return;
        }

        // Skip if clientInfo is still empty
        if (!clientInfo?.subscriptionPayment) return;

        if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
            navigate("/signin");
        }
    }, [clientInfo, navigate]);


    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state

        setBusinessData((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));

    };

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "clientd": localStorage.getItem("clientid"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }

    const handleChange = (event) => {
        const { name, value } = event.target;

        // Check if the field being updated is the phone number
        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = businessData?.idc?.trim(); // Directly get the latest idc value

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }
            setError({ ...error, phone: "" })
            // Update the phone number only
            setBusinessData(prev => ({ ...prev, [name]: formattedValue }));

        } else if (name === "businessname") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setBusinessData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...error, businessname: "" })

        } else if (name === "emailId") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setBusinessData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...error, emailId: "" })

        } else {
            // Allow normal updates for other fields
            setBusinessData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the changed field
            }));
        }
    };



    const handleAddressChange = (addressData) => {
        setBusinessData(prevState => ({
            ...prevState,
            businessaddress: addressData.fullAddress || ''
        }));
        setError((prevError) => ({
            ...prevError,
            businessaddress: "",
        }));
    };
    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection": "tiny"
            });

            const countries = response?.result?.data || [];
            setCountries(countries);
            const usaCountry = countries.filter(
                eachItem => eachItem.countrycode.trim() === "(+1)" && eachItem.alpha2.trim() === "US"
            );

            // Print the filtered country in the console
            console.log("USA Country:", usaCountry);




        } catch {
            console.log("error");
        }
    };
    const handleFileChange = (event) => {
        console.log("event.target.files[0]", event.target.files[0])
        const selectedFile = event.target.files[0];
        // const selectedFilesSize = selectedFile.size; //for single file
        const selectedFiles = Array.from(event.target.files);  //for multiple files

        const allowedFileTypes = ["image/jpeg", "image/png", "image/heic"];
        let fileSize = 1048612 * 5 // 5MB
        if (selectedFile && !allowedFileTypes.includes(selectedFile.type)) {
            setToastMessage("Only JPG, PNG, and HEIC files are allowed!");
            setToastMessage("warning")
            event.target.value = null;
            return;
        } else

            if (selectedFile.size < fileSize) {
                const previewUrl = URL.createObjectURL(selectedFile);
                setBusinessData(prev => ({
                    ...prev,
                    logo: [{ filepath: previewUrl }]
                }));
                setFilesData([selectedFile]); // Store file data

            } else {
                setToastMessage("File size should not exceed 5MB"); // Set the error message
                setToastMessage("warning")
                event.target.value = null;

            }




        // setFiles([...files, ...selectedFiles]); //for multiple files




    };




    const handleUploadSubmit = async () => {
        setBtnLoader(true)
        const ObjectID = require("bson-objectid");
        const uniqueId = new ObjectID().toString();
        // setLocationId(locationId)






        if (filesData && filesData?.length > 0) {
            setDisableSaveBtn(true)
            const uploadPromises = Array.from(filesData).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('userId');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;

                // Check the file type
                if (file.type.startsWith('image/')) {
                    // File is an image
                    let filenameReplace = file.name.replace(/ /g, "_")
                    uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
                    const data = {
                        source_bucket: bucket, // Use the correct bucket based on file type
                        sourcepath: uploadFilePath
                    };
                    console.log("data", data)
                    const newFile = [{
                        filename: filenameReplace.split('.')[0],
                        filepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    }]
                    const updatedFiles = [...files, ...newFile];
                    console.log("updatedFiles", updatedFiles)
                    setFiles(updatedFiles);

                    const uploadPromise = axios.post(
                        `${lambda}/uploadURL?appname=${appname}`,
                        data,
                        { headers: { 'Content-Type': 'application/json' } }
                    ).then(async uploadUrlResponse => {
                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const url = uploadUrlResponse.data.result;

                            return axios.put(url, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            }).then(async uploadResponse => {
                                if (uploadResponse.status === 200) {
                                    // setFiles([...files, ...newFile]); 
                                    // handleSubmit(updatedFiles);

                                    handleUpdate(updatedFiles);


                                } else {
                                    throw new Error('Failed to upload file to S3');
                                }
                            });
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    });


                }


            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);

            } catch (error) {
                console.error('Error during file upload:', error);
            }
        } else {
            // handleSubmit([], uniqueId);




            handleUpdate([], uniqueId);



        }



    }
    const getclient = async (e) => {
        GetTimeActivity(); // Ensure this function is defined elsewhere

        const token = localStorage.getItem("token");


        try {
            const response = await tmdbApi.getClientInfo();

            if (response?.result?.length > 0) {
                setBusinessData(response.result[0]);
                setClientInfo(response.result[0])
            }
        } catch (error) {
            console.error("Error fetching client info:", error);
        }
    };
    const handleUpdate = (filesData) => {
        GetTimeActivity()
        setDisableSaveBtn(true)


        let logoImage = filesData?.[0]?.filepath;



        let payload = {
            businessname: businessData?.businessname ? businessData.businessname.trim() : "",
            idc: businessData?.idc ?? "",
            phone: businessData?.phone ? businessData.phone.trim() : "",
            emailId: businessData?.emailId ? businessData.emailId.trim() : "",
            // subscription: businessData?.subscription ? businessData.subscription.trim() : "",
            businessaddress: businessData?.businessaddress ? businessData.businessaddress.trim() : "",
            logo: filesData?.length > 0 ? logoImage : businessData?.logo ?? "",
        };


        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")

        axios.post(lambda + '/updateClient?appname=' + appname + '&clientid=' + clientInfo?.clientid, payload,)
            // "&token=" + token 
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        setBtnLoader(false)
                        getclient()

                        setIsLoading(false);
                        setToastMessage("Client Details Updated Successfully")
                        setToastType("success")

                    }
                }
            }).catch((err) => {
                setIsLoading(false);
                console.log('errr', err)
            });

        // }
    }
    const handleValidations = () => {
        let formIsValid = true;

        // Safely trim values
        const businessname = businessData?.businessname?.trim() || "";
        const businessaddress = businessData?.businessaddress?.trim() || "";
        const phone = businessData?.phone?.trim() || "";
        const emailId = businessData?.emailId?.trim() || "";
        const idc = businessData?.idc?.trim() || "";

        // Name validation
        if (businessname === "") {
            setError(prev => ({ ...prev, businessname: "Please enter Name" }));
            formIsValid = false;
        } else {
            setError(prev => ({ ...prev, businessname: "" }));
        }

        // Address validation
        if (businessaddress === "") {
            setError(prev => ({ ...prev, businessaddress: "Please enter business address" }));
            formIsValid = false;
        } else {
            setError(prev => ({ ...prev, businessaddress: "" }));
        }

        // Phone validation
        if (phone === "") {
            setError(prev => ({ ...prev, phone: "Please enter phone number" }));
            formIsValid = false;
        } else if (
            (idc === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(phone)) ||
            (idc === "IND" && !/^\d{5}-\d{5}$/.test(phone))
        ) {
            setError(prev => ({ ...prev, phone: "Invalid phone number format" }));
            formIsValid = false;
        } else {
            setError(prev => ({ ...prev, phone: "" }));
        }

        // Email validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (emailId === "") {
            setError(prev => ({ ...prev, emailId: "Please enter Email" }));
            formIsValid = false;
        } else if (!emailRegex.test(emailId)) {
            setError(prev => ({ ...prev, emailId: "Please enter a valid Email address" }));
            formIsValid = false;
        } else {
            setError(prev => ({ ...prev, emailId: "" }));
        }

        return formIsValid;
    };

    const handleSave = () => {
        const validate = handleValidations()
        if (validate) {
            handleUploadSubmit()
        }

    }

    const handleRemove = () => {
        // setUploadImg("")
        //setFormData("")
        setFilesData([])
        setBusinessData(prev => ({
            ...prev,
            logo: ""// Clear the logo array
        }));
    }

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                {/* Start right Content here  */}

                <div className="main-content user-management" id="businessprofile-main-content">

                    <div className="page-content" id="businessprofile-page-content">
                        <div className="container-fluid" id="businessprofile-container-fluid">

                            <div className="row breadcrumb" id="businessprofile-breadcrumb-row">
                                <div className="col-lg-12" id="businessprofile-breadcrumb-col">
                                    <div className="d-flex align-items-center" id="businessprofile-breadcrumb-align">
                                        <div className="flex-grow-1" id="businessprofile-breadcrumb-flex-grow">
                                            <h4 className="mb-2 card-title" id="businessprofile-title">BUSINESS PROFILE</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="businessprofile-table-data-row">
                                <div className="col-12" id="businessprofile-table-data-col">
                                    <div className="card" id="businessprofile-card">
                                        <div className="card-body Bussiness-Profile" id="businessprofile-card-body">

                                            {/* Business Profile Start here */}
                                            <div className="row" id="businessprofile-form-row">
                                                <div className="col-md-6" id="businessprofile-left-col">

                                                    <div className="input_group_wrapper" id="businessprofile-businessname-wrapper">
                                                        <label className="form_label" htmlFor="businessprofile-businessname-input">
                                                            BUSINESS NAME <span className="required">*</span>
                                                        </label>
                                                        <div className="input_group" id="businessprofile-businessname-input-group">
                                                            <div className="icon_wrapper" id="businessprofile-businessname-icon-wrapper">
                                                                <span className="material-symbols-outlined" id="businessprofile-businessname-icon">storefront</span>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Business Name"
                                                                name="businessname"
                                                                id="businessprofile-businessname-input"
                                                                value={businessData?.businessname}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        {error && (
                                                            <span
                                                                className="errormsg"
                                                                style={{ fontWeight: 'bold', color: 'red' }}
                                                                id="businessprofile-businessname-error"
                                                            >
                                                                {error?.businessname}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <div className="input_group_wrapper mt-3" id="businessprofile-email-wrapper">
                                                        <label className="form_label" htmlFor="businessprofile-email-input">
                                                            BUSINESS EMAIL <span className="required">*</span>
                                                        </label>
                                                        <div className="input_group" id="businessprofile-email-input-group">
                                                            <div className="icon_wrapper" id="businessprofile-email-icon-wrapper">
                                                                <span className="material-symbols-outlined" id="businessprofile-email-icon">mail</span>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="businessprofile-email-input"
                                                                name="emailId"
                                                                value={businessData?.emailId}
                                                                placeholder="Email"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        {error && (
                                                            <span
                                                                className="errormsg"
                                                                style={{ fontWeight: 'bold', color: 'red' }}
                                                                id="businessprofile-email-error"
                                                            >
                                                                {error?.emailId}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <label className="form_label mt-3" htmlFor="businessprofile-phone-input">
                                                        BUSINESS PHONE NUMBER <span className="required">*</span>
                                                    </label>
                                                    <div className="input-group mb-2 mr-sm-2" id="businessprofile-phone-input-group">
                                                        <div className="input-group-prepend" id="businessprofile-phone-prepend">
                                                            <div className="input-group-text" id="businessprofile-phone-prepend-text">
                                                                <span className="material-symbols-outlined" id="businessprofile-phone-icon">call</span>
                                                            </div>
                                                        </div>
                                                        <select
                                                            name="idc"
                                                            className="colorselect capitalize"
                                                            id="businessprofile-country-code-select"
                                                            onChange={handleCountryChange}
                                                            value={businessData?.idc}
                                                        >
                                                            {countries &&
                                                                countries.length > 0 &&
                                                                countries.map((task, i) => (
                                                                    <option key={i} value={task.alpha3} id={`businessprofile-country-option-${i}`}>
                                                                        {task.alpha3}
                                                                        {task.countrycode}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                        <input
                                                            className="form-control"
                                                            name="phone"
                                                            id="businessprofile-phone-input"
                                                            value={businessData?.phone}
                                                            placeholder="Enter Phone Number"
                                                            onChange={handleChange}
                                                        />
                                                        {error && (
                                                            <span
                                                                className="errormsg"
                                                                style={{ fontWeight: 'bold', color: 'red' }}
                                                                id="businessprofile-phone-error"
                                                            >
                                                                {error?.phone}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <label className="form_label mt-3" htmlFor="businessprofile-address-input">
                                                        BUSINESS ADDRESS <span className="required">*</span>
                                                    </label>
                                                    <div className="input-group mb-2 mr-sm-2" id="businessprofile-address-input-group">
                                                        <div className="input-group-prepend" id="businessprofile-address-prepend">
                                                            <div className="input-group-text" id="businessprofile-address-prepend-text">
                                                                <span className="material-symbols-outlined" id="businessprofile-address-icon">location_on</span>
                                                            </div>
                                                        </div>
                                                        {mapsAPIkey !== false && (
                                                            <LocationSearch
                                                                setSelectedPlace={(place) => {
                                                                    setSelectedPlace(place);
                                                                    handleAddressChange(addressData);
                                                                }}
                                                                setAddressData={(data) => {
                                                                    setAddressData(data);
                                                                    handleAddressChange(data);
                                                                }}
                                                                onChange={(e) => {
                                                                    setBusinessData((prev) => ({ ...prev, businessaddress: e.target.value }));
                                                                    setAddressData({ fullAddress: e.target.value });
                                                                }}
                                                                onBlur={() => handleAddressChange({ fullAddress: businessData?.businessaddress })}
                                                                mapVisible={false}
                                                                formData={businessData}
                                                                mapsAPIkey={mapsAPIkey}
                                                                id="businessprofile-address-input"
                                                            />
                                                        )}
                                                        {error && (
                                                            <span
                                                                className="errormsg"
                                                                style={{ fontWeight: 'bold', color: 'red' }}
                                                                id="businessprofile-address-error"
                                                            >
                                                                {error?.businessaddress}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <label className="form_label mt-3" htmlFor="businessprofile-logo-upload">
                                                        Upload Logo
                                                    </label>

                                                    <div className="upload-zone input-group mb-2 mr-sm-2" id="businessprofile-logo-upload-zone">
                                                        {businessData?.logo?.length > 0 ?
                                                            <div className="upload-icon mt-1" id="businessprofile-logo-uploaded">
                                                                <div className="img_block add_img_block" id="businessprofile-logo-image-block">
                                                                    <span className="material-icons-outlined thumbnail-cls-icon" onClick={handleRemove} id="businessprofile-logo-remove-icon">close</span>

                                                                    <img
                                                                        src={
                                                                            Array.isArray(businessData?.logo) && businessData?.logo.length > 0
                                                                                ? businessData?.logo[0]?.filepath
                                                                                : image + businessData?.logo || "" // Fallback to an empty string if no valid image is found
                                                                        }
                                                                        id="activimg"
                                                                    // id="businessprofile-logo-image"
                                                                    />
                                                                    {/* <img id="activimg" src={uploadImg ? uploadImg : "assets/img/store-thumb-img.jpg"} width={150} /> */}
                                                                </div>
                                                            </div> :
                                                            <>

                                                                {/* <div>

                                                                    <input
                                                                        type="file"
                                                                       id="businessprofile-file-upload"
                                                                        accept="image/jpeg, image/png,image/heic,image/jpg"
                                                                        className="d-none"
                                                                        multiple={false}
                                                                        onChange={handleFileChange}
                                                                        style={{ display: 'none' }}
                                                                    />

                                                                    <label
                                                                        htmlFor="file-upload" className="stroke-button"
                                                                        id="businessprofile-file-upload-label">
                                                                        <span className="material-icons" id="businessprofile-file-upload-icon">file_upload</span>
                                                                    </label>
                                                                </div> */}
                                                                <div>
                                                                    <input
                                                                        type="file"
                                                                        id="businessprofile-file-upload"
                                                                        accept="image/jpeg, image/png, image/heic, image/jpg"
                                                                        className="d-none"
                                                                        multiple={false}
                                                                        onChange={handleFileChange}
                                                                        style={{ display: 'none' }}
                                                                    />
                                                                    <label
                                                                        htmlFor="businessprofile-file-upload"
                                                                        className="stroke-button"
                                                                        id="businessprofile-file-upload-label"
                                                                    >
                                                                        <span className="material-icons">file_upload</span>
                                                                    </label>
                                                                </div>

                                                                <div className="file_requirements " id="businessprofile-file-requirements">
                                                                    <p>Maximum file size: 5MB</p>
                                                                    <p>Supported formats: JPG, PNG, HEIC</p>
                                                                </div></>

                                                        }
                                                    </div>

                                                    <button className="fill-btn save_continue" id="businessprofile-save-button" onClick={handleSave}>
                                                        {btnLoader ? (
                                                            <img
                                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                                className="loading-icon"
                                                                alt="Loading"
                                                                id="businessprofile-loading-icon"
                                                            />
                                                        ) : null}
                                                        Update
                                                    </button>
                                                </div>

                                                <div className="col-md-6" id="businessprofile-right-col"></div>
                                            </div>
                                            {/* Business Profile End here */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <SweetAlert
                            show={tableErrMsg}
                            custom
                            confirmBtnText="ok"
                            confirmBtnBsStyle="primary"
                            title={"Something went wrong. Please reload again."}
                            onConfirm={(e) => setTableErrMsg(false)}
                            id="businessprofile-alert-error"
                        />

                        <Footer id="businessprofile-footer" />

                        <ToastContainer
                            position="bottom-center"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover={false}
                            theme="light"
                            id="businessprofile-toast-container"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default BusinessProfile;
